<template lang="pug">
.container(id="Linker-container")
  .button-container
    el-button.linker-button.enabled(
      type="primary",
      id="Linker-addChoiceButton",
      @click="showAddChoice()",
      circle
    )
      font-awesome-icon.linker-icon(icon="plus")
    p.describe-button-text(:class="") {{$t('add')}}
  .button-container
    el-button.linker-button(
      type="primary",
      @click="showAssign()",
      id="Linker-assignButton",
      :class="{ enabled: (assignableMediaSelectedLeft && assignTargetsSelectedRight) }",
      circle
    )
      font-awesome-icon.linker-icon(icon="link")
    p.describe-button-text(:class="") {{$t('assign')}}
  el-dialog(:close-on-click-modal="false", :close-on-press-escape="!jobInProgres", title='', :visible.sync='showAssignDialog', width="80%", @close="closeAssign()")
    AssignDialog(v-if='showAssignDialog', @linkerJobDone = 'linkerJobDone', @linkerJobStarted = 'linkerJobStarted', :enabled='assignableMediaSelectedLeft && assignTargetsSelectedRight')
  el-dialog(:close-on-click-modal="false", :close-on-press-escape="!jobInProgres", title='', :visible.sync='showGroupDialog', width="50%", @close="closeGroup()")
    GroupDialog(v-if='showGroupDialog', @linkerJobDone = 'linkerJobDone', @linkerJobStarted = 'linkerJobStarted')
  el-dialog(:close-on-click-modal="false", :close-on-press-escape="!jobInProgres", title='', :visible.sync='showApplyExtensionDialog', width="80%", @close="closeAddExtension()")
    ApplyExtensionDialog(v-if='showApplyExtensionDialog', @linkerJobDone = 'linkerJobDone', @linkerJobStarted = 'linkerJobStarted')
  el-dialog(:close-on-click-modal="false", :close-on-press-escape="!jobInProgres", title='', :visible.sync='showDeleteDialog', width="50%", @close="closeDelete()")
    DeleteDialog(v-if='showDeleteDialog', ref="DeleteDialog", @linkerJobDone = 'linkerJobDone', @linkerJobStarted = 'linkerJobStarted')
  el-dialog(:close-on-click-modal="false", :close-on-press-escape="!jobInProgres", title='', :visible.sync='showCreateDialog', width="100%", @close="closeCreate()")
    CreatePlayListDialog(
      v-if='showCreateDialog',
      @linkerJobDone = 'linkerJobDone',
      @linkerJobStarted = 'linkerJobStarted',
      @loadEditMediumInMediaEditor = 'loadEditMediumInMediaEditor',
      :choice='choice'
    )
  el-dialog(:close-on-click-modal="false", :close-on-press-escape="!jobInProgres", title='', :visible.sync='showReplaceDialog', width="50%", @close="closeReplace()")
    ReplaceDialog(v-if='showReplaceDialog', @linkerJobDone = 'linkerJobDone', @linkerJobStarted = 'linkerJobStarted', :type='replaceType', :newMedium='newMedium')
  el-dialog(:close-on-click-modal="false", :close-on-press-escape="!jobInProgres", title='', :visible.sync='showReplaceByNameDialog', width="80%", @close="closeReplaceByName()")
    ReplaceByNameDialog(v-if='showReplaceByNameDialog', @linkerJobDone = 'linkerJobDone', @linkerJobStarted = 'linkerJobStarted', :type='replaceType')
  el-dialog(:close-on-click-modal="false", :close-on-press-escape="!jobInProgres", title='', :visible.sync='showPasteTagsDialog', width="50%", @close="closePasteTags()")
    PasteTagsDialog(v-if='showPasteTagsDialog', @linkerJobDone = 'linkerJobDone', @linkerJobStarted = 'linkerJobStarted')
  el-dialog(:close-on-click-modal="false", :close-on-press-escape="!jobInProgres", title='', :visible.sync='showAddChoiceDialog', width="50%", @close="closeAddChoice()")
    AddChoiceDialog(v-if='showAddChoiceDialog', @addChoiceMade = 'addChoiceMade')
  el-dialog(:close-on-click-modal="false", :close-on-press-escape="!jobInProgres", title='', :visible.sync='showDuplicatePlaylistRecursiveDialog', width="50%", @close="closeDuplicatePlaylistRecursive()")
    DuplicateRecursiveDialog(v-if='showDuplicatePlaylistRecursiveDialog', :multiplePlaylists='multiplemode', @linkerJobDone = 'linkerJobDone', @linkerJobStarted = 'linkerJobStarted')
</template>

<script>
import Vue from 'vue'
import mediaUtilsMixin from '../Common/mediaUtils.mixin'
import AssignDialog from './DialogAssign'
import GroupDialog from './DialogGroup'
import DuplicateRecursiveDialog from './DialogDuplicateRecursive'
import ApplyExtensionDialog from './ApplyExtensionDialog'
import DeleteDialog from './DialogDelete'
import CreatePlayListDialog from './DialogPlayListCreate'
import ReplaceDialog from './DialogReplace'
import ReplaceByNameDialog from './DialogReplaceByName'
import PasteTagsDialog from './DialogPasteTags'
import AddChoiceDialog from './DialogAddChoice'

export default {
  props: ['side'],
  mixins: [mediaUtilsMixin],
  created () {

  },
  components: {
    AssignDialog,
    GroupDialog,
    ApplyExtensionDialog,
    DeleteDialog,
    CreatePlayListDialog,
    ReplaceDialog,
    ReplaceByNameDialog,
    PasteTagsDialog,
    AddChoiceDialog,
    DuplicateRecursiveDialog
  },
  data () {
    return {
      errors: {},
      showAssignDialog: false,
      showDeleteDialog: false,
      showCreateDialog: false,
      showReplaceDialog: false,
      showPasteTagsDialog: false,
      showGroupDialog: false,
      showAddChoiceDialog: false,
      showApplyExtensionDialog: false,
      showReplaceByNameDialog: false,
      showDuplicatePlaylistRecursiveDialog: false,
      choice: undefined,
      replaceType: undefined,
      newMedium: undefined,
      jobInProgres: false,
      multiplemode: false
    }
  },
  methods: {
    async addChoiceMade (choice) {
      this.choice = choice
      switch (choice) {
        case 'Upload':
        case 'UploadHTMLzip':
        case 'UploadFile':
          await this.$router.push({ path: '/layout-full/Library/' + this.$route.params.rightPanel + '/' + this.$route.params.mediumEditor })
          Vue.nextTick()
            .then(() => {
              this.$emit('uploadRequested', choice)
            })
          break
        case 'PlayListLibrary':
          await this.$router.push({ path: '/layout-full/Library/' + this.$route.params.rightPanel + '/' + this.$route.params.mediumEditor })
          Vue.nextTick()
            .then(() => {
              this.$emit('createFolderRequested')
            })
          break
        case 'PlayList':
        case 'PlayListLayout':
          this.showCreate()
          break
        case 'DesktopGroup':
          this.showGroup()
          break
        case 'Extension':
          this.showAddExtension()
          break
        default:
          console.error('Unknown choice', choice)
          break
      }
      this.closeAddChoice()
    },
    showAddChoice () {
      this.showAddChoiceDialog = true
    },
    closeAddChoice () {
      this.showAddChoiceDialog = false
    },
    showAssign () {
      this.showAssignDialog = true
    },
    closeAssign () {
      this.showAssignDialog = false
    },
    showGroup () {
      this.showGroupDialog = true
    },
    closeGroup () {
      this.showGroupDialog = false
    },
    showAddExtension () {
      this.showApplyExtensionDialog = true
    },
    closeAddExtension () {
      this.showApplyExtensionDialog = false
    },
    showDelete () {
      this.showDeleteDialog = true
    },
    closeDelete () {
      this.$refs.DeleteDialog.selectedItemsChanged([])
      this.showDeleteDialog = false
    },
    showCreate () {
      this.showCreateDialog = true
    },
    closeCreate () {
      this.showCreateDialog = false
    },
    showReplace (type, newNedium) {
      this.replaceType = type
      this.newMedium = newNedium
      this.showReplaceDialog = true
    },
    showReplaceByName () {
      this.showReplaceByNameDialog = true
    },
    closeReplaceByName () {
      this.showReplaceByNameDialog = false
    },
    closeReplace () {
      this.showReplaceDialog = false
    },
    showPasteTags () {
      this.showPasteTagsDialog = true
    },
    closePasteTags () {
      this.showPasteTagsDialog = false
    },
    showDuplicatePlaylistRecursive (multiplemode = false) {
      this.multiplemode = multiplemode
      this.showDuplicatePlaylistRecursiveDialog = true
    },
    closeDuplicatePlaylistRecursive () {
      this.showDuplicatePlaylistRecursiveDialog = false
    },
    linkerJobStarted () {
      this.jobInProgres = true
    },
    linkerJobDone (data) {
      this.jobInProgres = false
      this.$emit('linkerJobDone', data)
      this.showAssignDialog = false
      this.showDeleteDialog = false
      this.showCreateDialog = false
      this.showReplaceDialog = false
      this.showPasteTagsDialog = false
      this.showGroupDialog = false
      this.showApplyExtensionDialog = false
      this.showReplaceByNameDialog = false
      this.showDuplicatePlaylistRecursiveDialog = false
    },
    loadEditMediumInMediaEditor (mediumId) {
      this.$emit('loadEditMediumInMediaEditor', this.getMediumById(mediumId))
    }
  },
  computed: {
  }
}
</script>
<style lang='scss' scoped>
@import "../../../theme-m4b/src/common/var.scss";
.container {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 285px);
  margin-top: calc(20vh);
  .button-container {
    &.invisible {
      display: none;
    }
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 10px 0px;
    text-align: center;
    .linker-icon {
      font-size:20px;
    }
    .describe-button-text {
      margin: 0px;
      margin-top: 5px;
      font-size: 10px;
      text-transform: uppercase;
    }
    &.enabled {
      opacity: 1;
      cursor: pointer;
    }
    .linker-button {
      width: 53px;
      height: 53px;
      margin: auto;
      opacity: 0.3;
      cursor: not-allowed;
      &.enabled {
        opacity: 1;
        cursor: pointer;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Linker/Linker.vue